import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PageLayout from 'layouts/PageLayout';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ROLES } from 'appConstants';
import ComplianceDetails from 'pages/Students/Edit/CourseDetails/ComplianceDetails';
import { evaluateUserCompliance, recalculateAllCompliance } from 'http/compliance';

const MyCompliance = () => {
  const { t } = useTranslation('common');
  const profile = useSelector(state => state.auth.profile);
  const userId = profile?.id;
  const role = profile?.role;
  const [refreshVersion, setRefreshVersion] = useState(0);
  const [isRecalculating, setIsRecalculating] = useState(false);

  const isStudent = role === ROLES.USER || role === 'user';
  const isHyperAdmin = role === ROLES.HYPER;

  const handleRecalculateSelf = async () => {
    if (!userId) {
      return;
    }

    setIsRecalculating(true);
    try {
      await evaluateUserCompliance(userId);
      setRefreshVersion(value => value + 1);
      toast.success(t('compliance.recalculateDone'));
    } catch (error) {
      toast.error(error?.response?.data?.message || t('errors.serverError'));
    } finally {
      setIsRecalculating(false);
    }
  };

  const handleRecalculateAll = async () => {
    setIsRecalculating(true);
    try {
      const result = await recalculateAllCompliance();
      toast.success(
        t('compliance.recalculateAllDone', {
          processed: result?.processedStudents ?? 0,
          failed: result?.failedStudents ?? 0,
        }),
      );
    } catch (error) {
      toast.error(error?.response?.data?.message || t('errors.serverError'));
    } finally {
      setIsRecalculating(false);
    }
  };

  return (
    <PageLayout
      pageTitle={t('routes.myCompliance')}
      actionSectionRight={[
        isStudent
          ? {
              type: 'button',
              icon: 'autorenew',
              title: t('compliance.recalculateSelf'),
              onClick: handleRecalculateSelf,
              disabled: isRecalculating,
            }
          : null,
        isHyperAdmin
          ? {
              type: 'button',
              icon: 'sync',
              title: t('compliance.recalculateAll'),
              onClick: handleRecalculateAll,
              disabled: isRecalculating,
            }
          : null,
      ].filter(Boolean)}
    >
      {isStudent && userId ? <ComplianceDetails userId={userId} refreshVersion={refreshVersion} /> : null}
    </PageLayout>
  );
};

export default MyCompliance;
